/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getOnlineTest: state => (id) => state.onlineTests.find((onlineTest) => onlineTest.id == id),
  // getNotice: state => (id) => state.notices.find((notice) => notice.id == id)
  filteredOnlineTest: state => state.onlineTests.filter((onlineTest) => {
    return (onlineTest.name.toLowerCase().includes(state.onlineTestSearchQuery.toLowerCase()) || onlineTest.title.toLowerCase().includes(state.onlineTestSearchQuery.toLowerCase()) ||
    onlineTest.update_time.toLowerCase().includes(state.onlineTestSearchQuery.toLowerCase()) || onlineTest.detail.toLowerCase().includes(state.onlineTestSearchQuery.toLowerCase()))
  }),
}
